const panel = () => {
    $('#phone').mask('000000000');
    $('#nip').mask('0000000000');
    
    $('.price-input input').mask("#0,00", {reverse: true}); 
    //mask('000000', {reverse: true});
    
    //welcome cookie
    if(true) {
        $('#welcome-info').slideDown();
    }

    $('#btn-close-welcome-info').click(function(){
        $('#welcome-info').slideUp();
        
        // set welcome cookie
    });
    
    $('.notification').click(function(e){
        //e.preventDefault();
        if ($(this).hasClass('open')){
            $('#notification-popup').fadeOut();
            $(this).removeClass('open');
        } else {
            $('#notification-popup').fadeIn();
            $(this).addClass('open');

            var bubble = $('.notification span');
            
            if (bubble.length > 0){
            
                var ajaxUrl = $(this).attr('path');

                var filedata = {
                    justDone: true,
                };

                $.ajax({
                    type: 'POST',
                    data: filedata,
                    dataType: "json",
                    url: ajaxUrl + 'ajax/panel/profile/doneNotifications',
                    success: function(response) {
                        bubble.fadeOut(function(){
                            bubble.remove();
                        });
                    },
                    error: function(response) {

                    }
                });
            }
        }
    });
    
    // PROFILE DROPZONES
    var dropzonePreviewTemplate = "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>";
    var uploadUrl = $('#upload-profile-image').val(); 

    function deleteProfileImage(imageIndex) {
        var filedata = {
            imageIndex: imageIndex,
        };

        var ajaxUrl = $('.pictures-profile').attr('path');

        $.ajax({
            type: 'POST',
            data: filedata,
            dataType: "json",
            url: ajaxUrl + 'ajax/panel/profile/deleteImage',
            success: function(response) {

            },
            error: function(response) {

            }
        });
    }

    if(uploadUrl){
        
        var dropzoneImage1 = new Dropzone("#profileImage1", {
            addRemoveLinks: true,
            url: uploadUrl,
            thumbnailWidth: null,
            thumbnailHeight: 200,
            dictRemoveFile: "",
            dictCancelUpload: "",
            dictDefaultMessage: "Kliknij, lub przeciągnij tu obrazek.",
            previewTemplate: dropzonePreviewTemplate,
            paramName: "file1",
            acceptedFiles: "image/*",
            maxFilesize: 2,
            //maxFiles: 1
        });

        var mockFile1 = { name: "Filename1", size: 12345 };
        var mockFileUrl1 = $("#file1db").val();

        if(mockFileUrl1 != "") {
            dropzoneImage1.emit("addedfile", mockFile1);
            dropzoneImage1.emit("thumbnail", mockFile1, mockFileUrl1);
            dropzoneImage1.emit("complete", mockFile1);
        }        

        dropzoneImage1.on("removedfile", function(file) {
            deleteProfileImage(1);
        });
        
        /*
        dropzoneImage1.on("maxfilesexceeded", function(file) {
            deleteProfileImage(1);
            this.addFile(file);
        });
        */
        
        $('#btn-upload-avatar').click(function(e){
            e.preventDefault();
            dropzoneImage1.hiddenFileInput.click();
        })

    }
    
    // Profile FORM
    var profile_form_options = {
        beforeSubmit: function(arr, $form, options) {
            $("#profile-form .btn-submit").removeClass('done').addClass("processing").find("b").text("Zapisz");            
        },
        success: function(responseText, statusText, xhr, $form) {
            $("#profile-form .btn-submit").removeClass("processing").addClass("done").find("b").text("Zapisano");
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $("#profile-form .btn-submit").removeClass("processing");
        }
    };
    
    jQuery.validator.addMethod("nip", function(value, element) {
        var verificator_nip = new Array(6,5,7,2,3,4,5,6,7); 
        var nip = value.replace(/[\ \-]/gi, ''); 

        if (nip.length != 10)  {
            return false; 
        } else {
            var n = 0;

            for (var i=0; i<9; i++) {
                n += nip[i] * verificator_nip[i]; 
            }

            n %= 11;

            if (n != nip[9]) {
                return false;
            }
        }
        return true;	
    }, "Proszę o podanie prawidłowego numeru NIP");

    $('#profile-form').validate({
        ignore: [],
        rules: {
            fullName: {
                required: true,
            },
            nip: {
                nip: true,
                required: true,
            },
            representingPerson: {
                required: true,
            },
            street: {
                required: true,
            },
            postalCode: {
                required: true,
            },
            city: {
                required: true,
            },
            contactPerson: {
                required: true,
            },            
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
            },
            accept1: {
                required: true,
            },
            accept2: {
                required: true,
            }
        },
        messages: {
            fullName: {
                required: "Wymagane",
            },
            nip: {
                required: "Wymagane",
            },
            representingPerson: {
                required: "Wymagane",
            },
            street: {
                required: "Wymagane",
            },
            postalCode: {
                required: "Wymagane",
            },
            city: {
                required: "Wymagane",
            },
            contactPerson: {
                required: "Wymagane",
            },            
            email: {
                required: "Wymagane",
                email: "Zły format e-mail"
            },
            phone: {
                required: "Wymagane",
            },
            accept1: {
                required: "Wymagane",
            },
            accept2: {
                required: "Wymagane",
            }
        },
        errorElement: 'span',
        focusInvalid: false,
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;
            
            var offset = $(validator.errorList[0].element).closest('.form-group').offset().top-100;
           
            $('html, body').animate({
                scrollTop: offset
            }, 500);
        },
        errorPlacement: function(error, element) {
            /*console.log(element[0].name);*/
            error.insertAfter(element).addClass('show');
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
        },
        submitHandler: function(form) {
            $(form).ajaxSubmit(profile_form_options);
        }
    });
    
    // Pass FORM
    var pass_form_options = {
        beforeSubmit: function(arr, $form, options) {
            $("#pass-form .btn-submit").removeClass('done').addClass("processing").find("b").text("Zapisz");
        },
        success: function(responseText, statusText, xhr, $form) {
            $("#pass-form .btn-submit").removeClass("processing").addClass("done").find("b").text("Zapisano");
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $("#pass-form .btn-submit").removeClass("processing");
        }
    };
    
    $('#pass-form').validate({
        ignore: [],
        rules: {
            newPass: {
                required: true,
            },
            newPassRepeat: {
                required: true,
                equalTo: "#newPass"
            }
            
        },
        messages: {
            newPass: {
                required: "Wymagane",
            },
            newPassRepeat: {
                required: "Wymagane",
                equalTo: "Hasła muszą się zagdzać"
            }
        },
        errorElement: 'span',
        focusInvalid: false,
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;
            
            var offset = $(validator.errorList[0].element).closest('.form-group').offset().top-100;
           
            $('html, body').animate({
                scrollTop: offset
            }, 500);
        },
        errorPlacement: function(error, element) {
            /*console.log(element[0].name);*/
            error.insertAfter(element).addClass('show');
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
        },
        submitHandler: function(form) {
            $(form).ajaxSubmit(pass_form_options);
        }
    });
    
    function calculatePrices(index){
        var priceToilet = parseFloat($('#priceToilet'+index).val().replace(',', '.')) || 0;
        // console.log(priceToilet);
        //$('#priceToilet'+index).val(priceToilet);
        $('#priceToiletValue'+index).html((priceToilet*4).toFixed(2).replace('.', ','));

        if (index == 1){
            var priceService = parseFloat($('#priceService'+index).val().replace(',', '.')) || 0;
        }
        
        if (index == 2){
            var priceService = parseFloat($('#priceService'+index).val().replace(',', '.')) * 2 || 0;
        }
        
        if (index == 3){
            var priceService = parseFloat($('#priceService'+index).val().replace(',', '.')) * 4 || 0;
        }
        
        //$('#priceService'+index).val(priceService);
        $('#priceServiceValue'+index).html(priceService.toFixed(2).replace('.', ','));
        // console.log(priceToilet);

        // console.log(parseFloat(priceToilet*4 + priceService).toFixed(2));
        $('#priceTotalValue'+index).html(parseFloat(priceToilet*4 + priceService).toFixed(2).replace('.', ','));
    }
    
    function calculatePreview(index){
        var vat = 0.08;
        var priceToilet = parseFloat($('#priceToilet'+index).val().replace(',', '.')) || 0;
        
        if (index == 1){
            var priceService = parseFloat($('#priceService'+index).val().replace(',', '.')) || 0;
        }
        
        if (index == 2){
            var priceService = parseFloat($('#priceService'+index).val().replace(',', '.')) * 2 || 0;
        }
        
        if (index == 3){
            var priceService = parseFloat($('#priceService'+index).val().replace(',', '.')) * 4 || 0;
        }
        
        // var priceDelivery = parseFloat($('#priceDelivery'+index).val().replace(',', '.')) || 0;
        var priceDelivery = 0;
        var total = parseFloat(priceToilet*4 + priceService + priceDelivery);
        total = total + (total * vat);
        $('.price-preview'+index).html(parseFloat(total).toFixed(2).replace('.', ',') + ' pln');
        $('.delivery-preview'+index).html('W tym koszt transportu ' + parseFloat(priceDelivery + (priceDelivery * vat)).toFixed(2).replace('.', ',') + ' pln');
    }
    
    $('#priceToilet1, #priceService1').on('keyup', function(){
        calculatePrices(1);
        calculatePreview(1);
    });
    
    $('#priceToilet2, #priceService2').on('keyup', function(){
        calculatePrices(2);
        calculatePreview(2);
    });
    
    $('#priceToilet3, #priceService3').on('keyup', function(){
       calculatePrices(3);
       calculatePreview(3);
    });
    
    $('#priceDelivery1').on('keyup', function(){
       calculatePreview(1);
    });
    
    $('#priceDelivery2').on('keyup', function(){
       calculatePreview(2);
    });
    
    $('#priceDelivery3').on('keyup', function(){
       calculatePreview(3);
    });
    
    function showPricesPopup(serviceTxt, priceSaved){
        var popup = $('#prices-popup');
        // console.log(priceSaved);
        popup.find('.service-label').html(serviceTxt);
        popup.find('.'+priceSaved).addClass('saved').hide();
        
        var btnNotSaved = popup.find('.btn:not(.saved)');
        if(btnNotSaved.length == 0){
            popup.find('.all-saved').show();
        }
        
        if (popup.length) {
            $.magnificPopup.open({
                items: {
                    src: popup
                },
                type: 'inline',
                preloader: false,
                removalDelay: 900,

                callbacks: {
                    beforeOpen: function() {
                        
                    },
                    open: function() {
                        /*
                        $.magnificPopup.instance.close = function() {
                            $.magnificPopup.proto.close.call(this);
                        };
                        */
                    }
                }
            });        
        }
    }
    
    $("#prices-popup .close-popup").click(function(e){
        e.preventDefault();
        $.magnificPopup.close();
    });

    $("#prices-popup .price1").click(function(e){
        e.preventDefault();
        $.magnificPopup.close();
        $('#nav-prices1-tab').trigger('click');
    });

    $("#prices-popup .price2").click(function(e){
        e.preventDefault();
        $.magnificPopup.close();
        $('#nav-prices2-tab').trigger('click');
    });

    $("#prices-popup .price3").click(function(e){
        e.preventDefault();
        $.magnificPopup.close();
        $('#nav-prices3-tab').trigger('click');
    });
    
    jQuery.validator.addMethod(
        "money",
        function(value, element) {
            var isValidMoney = /^\d{0,6}(\,\d{0,2})?$/.test(value);
            return this.optional(element) || isValidMoney;
        }
    );
    
    // Prices1 FORM
    var prices1_form_options = {
        beforeSubmit: function(arr, $form, options) {
            $("#btn-submit-prices1").removeClass('done').addClass("processing").find("b").text("Zapisz");
        },
        success: function(responseText, statusText, xhr, $form) {
            $("#btn-submit-prices1").removeClass("processing").addClass("done").find("b").text("Zapisano");
            var serviceTxt = responseText.serviceTxt;
            var priceSaved = responseText.priceSaved;
            
            showPricesPopup(serviceTxt, priceSaved);
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $("#btn-submit-prices1").removeClass("processing");
        }
    };
    
    $('#prices1-form').validate({
        ignore: [],
        rules: {
            priceToilet: {
                required: true,
                money: true
            },
            priceService: {
                required: true,
                money: true
            },
            priceDelivery: {
                required: true,
                money: true
            },
            priceInsurance: {
                required: true,
                money: true
            },
            priceOther: {
                required: true,
                money: true
            }
        },
        messages: {
            priceToilet: {
                required: "Wymagane",
                money: "Zła kwota"
            },
            priceService: {
                required: "Wymagane",
                money: "Zła kwota"
            },
            priceDelivery: {
                required: "Wymagane",
                money: "Zła kwota"
            },
            priceInsurance: {
                required: "Wpisz przynajmniej 0",
                money: "Zła kwota"
            },
            priceOther: {
                required: "Wpisz przynajmniej 0",
                money: "Zła kwota"
            }
        },
        errorElement: 'span',
        focusInvalid: false,
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;
            
            var offset = $(validator.errorList[0].element).closest('.form-group').offset().top-100;
           
            $('html, body').animate({
                scrollTop: offset
            }, 500);
        },
        errorPlacement: function(error, element) {
            /*console.log(element[0].name);*/
            error.insertAfter(element).addClass('show');
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
        },
        submitHandler: function(form) {
            $(form).ajaxSubmit(prices1_form_options);
        }
    });
    
    // Prices2 FORM
    var prices2_form_options = {
        beforeSubmit: function(arr, $form, options) {
            $("#btn-submit-prices2").removeClass('done').addClass("processing").find("b").text("Zapisz");
        },
        success: function(responseText, statusText, xhr, $form) {
            $("#btn-submit-prices2").removeClass("processing").addClass("done").find("b").text("Zapisano");
            var serviceTxt = responseText.serviceTxt;
            var priceSaved = responseText.priceSaved;
            
            showPricesPopup(serviceTxt, priceSaved);
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $("#btn-submit-prices2").removeClass("processing");
        }
    };
    
    $('#prices2-form').validate({
        ignore: [],
        rules: {
            priceToilet: {
                required: true,
                money: true
            },
            priceService: {
                required: true,
                money: true
            },
            priceDelivery: {
                required: true,
                money: true
            },
            priceInsurance: {
                required: true,
                money: true
            },
            priceOther: {
                required: true,
                money: true
            }
        },
        messages: {
            priceToilet: {
                required: "Wymagane",
                money: "Zła kwota"
            },
            priceService: {
                required: "Wymagane",
                money: "Zła kwota"
            },
            priceDelivery: {
                required: "Wymagane",
                money: "Zła kwota"
            },
            priceInsurance: {
                required: "Wpisz przynajmniej 0",
                money: "Zła kwota"
            },
            priceOther: {
                required: "Wpisz przynajmniej 0",
                money: "Zła kwota"
            }
        },
        errorElement: 'span',
        focusInvalid: false,
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;
            
            var offset = $(validator.errorList[0].element).closest('.form-group').offset().top-100;
           
            $('html, body').animate({
                scrollTop: offset
            }, 500);
        },
        errorPlacement: function(error, element) {
            /*console.log(element[0].name);*/
            error.insertAfter(element).addClass('show');
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
        },
        submitHandler: function(form) {
            $(form).ajaxSubmit(prices2_form_options);
        }
    });
    
    // Prices3 FORM
    var prices3_form_options = {
        beforeSubmit: function(arr, $form, options) {
            $("#btn-submit-prices3").removeClass('done').addClass("processing").find("b").text("Zapisz");
        },
        success: function(responseText, statusText, xhr, $form) {
            $("#btn-submit-prices3").removeClass("processing").addClass("done").find("b").text("Zapisano");
            
            var serviceTxt = responseText.serviceTxt;
            var priceSaved = responseText.priceSaved;
            
            showPricesPopup(serviceTxt, priceSaved);
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $("#btn-submit-prices3").removeClass("processing");
        }
    };
    
    $('#prices3-form').validate({
        ignore: [],
        rules: {
            priceToilet: {
                required: true,
                money: true
            },
            priceService: {
                required: true,
                money: true
            },
            priceDelivery: {
                required: true,
                money: true
            },
            priceInsurance: {
                required: true,
                money: true
            },
            priceOther: {
                required: true,
                money: true
            }
        },
        messages: {
            priceToilet: {
                required: "Wymagane",
                money: "Zła kwota"
            },
            priceService: {
                required: "Wymagane",
                money: "Zła kwota"
            },
            priceDelivery: {
                required: "Wymagane",
                money: "Zła kwota"
            },
            priceInsurance: {
                required: "Wpisz przynajmniej 0",
                money: "Zła kwota"
            },
            priceOther: {
                required: "Wpisz przynajmniej 0",
                money: "Zła kwota"
            }
        },
        errorElement: 'span',
        focusInvalid: false,
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;
            
            var offset = $(validator.errorList[0].element).closest('.form-group').offset().top-100;
           
            $('html, body').animate({
                scrollTop: offset
            }, 500);
        },
        errorPlacement: function(error, element) {
            /*console.log(element[0].name);*/
            error.insertAfter(element).addClass('show');
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
        },
        submitHandler: function(form) {
            $(form).ajaxSubmit(prices3_form_options);
        }
    });
    
    
    
    
    
    
    // Prices4 FORM
    var prices4_form_options = {
        beforeSubmit: function(arr, $form, options) {
            $("#btn-submit-prices4").removeClass('done').addClass("processing").find("b").text("Zapisz");
        },
        success: function(responseText, statusText, xhr, $form) {
            $("#btn-submit-prices4").removeClass("processing").addClass("done").find("b").text("Zapisano");
            
            var serviceTxt = responseText.serviceTxt;
            var priceSaved = responseText.priceSaved;
            
            showPricesPopup(serviceTxt, priceSaved);
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $("#btn-submit-prices4").removeClass("processing");
        }
    };
    
    $('#prices4-form').validate({
        ignore: [],
        rules: {
            priceExpress: {
                required: true,
                money: true
            },
            expressHour: {
                required: true
            },
            expressAccept: {
                required: true
            }
        },
        messages: {
            priceExpress: {
                required: "Wymagane",
                money: "Zła kwota"
            },
            expressHour: {
                required: "Wymagane"
            },
            expressAccept: {
                required: "Wymagane"
            }
        },
        errorElement: 'span',
        focusInvalid: false,
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;
            
            var offset = $(validator.errorList[0].element).closest('.form-group').offset().top-100;
           
            $('html, body').animate({
                scrollTop: offset
            }, 500);
        },
        errorPlacement: function(error, element) {
            /*console.log(element[0].name);*/
            error.insertAfter(element).addClass('show');
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
        },
        submitHandler: function(form) {
            $(form).ajaxSubmit(prices4_form_options);
        }
    });
    
    // usługi w całej Polsce
    $('#all').on('click', function(){
        var allIsChecked = $(this).prop('checked');
        
        $('.card.top-card .fake-checkbox').each(function(){           
           if (allIsChecked) {
                $(this).addClass('checked');
                $(this).closest('.card-header').next().find('.fake-checkbox').addClass('checked');
                $(this).closest('.card-header').next().find('.checkbox input').prop('checked', true);
            } else {
                $(this).removeClass('checked');
                $(this).closest('.card-header').next().find('.fake-checkbox').removeClass('checked');
                $(this).closest('.card-header').next().find('.checkbox input').prop('checked', false);
            }

            var count = $(this).closest('.card.top-card').find('.checkbox input:checkbox:checked').length;
            $(this).closest('.card.top-card').find('.checked-count').html(count);
        });
    });

    $('.fake-checkbox').on('click', function(){
        $(this).toggleClass('checked');

        var isChecked = $(this).hasClass('checked');

        if (isChecked) {
            $(this).closest('.card-header').next().find('.fake-checkbox').addClass('checked');
            $(this).closest('.card-header').next().find('.checkbox input').prop('checked', true);
        } else {
            $(this).closest('.card-header').next().find('.fake-checkbox').removeClass('checked');
            $(this).closest('.card-header').next().find('.checkbox input').prop('checked', false);
            $('#all').prop('checked', false);
        }

        var count = $(this).closest('.card.top-card').find('.checkbox input:checkbox:checked').length;
        $(this).closest('.card.top-card').find('.checked-count').html(count);
           
    });
    
    $('.checkbox').on('click', function(){
        var count = $(this).closest('.card.top-card').find('.checkbox input:checkbox:checked').length;
        $(this).closest('.card.top-card').find('.checked-count').html(count);
       
        var isChecked = $(this).find('input').prop('checked');
        console.log(isChecked);
        if (!isChecked) {
            $('#all').prop('checked', false);
        }
    });
    
    // count checked items on startup
    $('.card.top-card').each(function(){
       var count = $(this).find('.checkbox input:checkbox:checked').length;
       $(this).find('.checked-count').html(count);
    });
    
    // SEARCH County and Community
    $('#area-search').keydown(function(e){
        var code = (e.keyCode ? e.keyCode : e.which);
        if(code == 13) {
            // run search function
            alert('SEARCH');
            e.preventDefault();
        }
    });
    
    // Areas FORM
    var areas_form_options = {
        beforeSubmit: function(arr, $form, options) {
            $("#btn-submit-areas").removeClass('done').addClass("processing").find("b").text("Zapisz");
        },
        success: function(responseText, statusText, xhr, $form) {
            $("#btn-submit-areas").removeClass("processing").addClass("done").find("b").text("Zapisano");
            var redirectUrl = $("#btn-submit-areas").attr('redirect-url');
            if (redirectUrl && redirectUrl !=""){
                window.open(redirectUrl,"_self");
            }
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $("#btn-submit-areas").removeClass("processing");
        }
    };
        
    $('#btn-submit-areas').on('click', function(e){
        e.preventDefault();
        $('#areas-form').ajaxSubmit(areas_form_options);
    });

    // OPINIONS
    // Answer FORM
    var answer_form_options = {
        beforeSubmit: function(arr, $form, options) {
            $form.find(".btn-submit").removeClass('done').addClass("processing").find("b").text("Zapisz");
        },
        success: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $form.find(".btn-submit").removeClass("processing").addClass("done").find("b").text("Zapisano");
            $form.slideUp(function(){
                $form.closest('.opinion').find('.answer p').html(responseText.answer);
                $form.closest('.opinion').find('.answer').slideDown();
            });
            
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $form.find(".btn-submit").removeClass("processing");
        }
    };
    
    $('.answer-form').each(function() {
        $(this).validate({
            ignore: [],
            rules: {
                answer: {
                    required: true,
                }
            },
            messages: {
                answer: {
                    required: "Wymagane",
                }
            },
            errorElement: 'span',
            focusInvalid: false,
            invalidHandler: function(form, validator) {
                if (!validator.numberOfInvalids())
                    return;

                var offset = $(validator.errorList[0].element).closest('.form-group').offset().top-100;

                $('html, body').animate({
                    scrollTop: offset
                }, 500);
            },
            errorPlacement: function(error, element) {
                /*console.log(element[0].name);*/
                error.insertAfter(element).addClass('show');
            },
            highlight: function(element) {
                $(element).parents('.form-group').removeClass('valid').addClass('error');
              },
            unhighlight: function(element) {
                $(element).parents('.form-group').removeClass('error').addClass('valid');
            },
            submitHandler: function(form) {
                $(form).ajaxSubmit(answer_form_options);
            }
        });
    });
    
    $('.add-answer').click(function(){
        var item = $(this).closest('.opinion');
        
        $(this).slideUp(function(){
            item.find('.answer-form').slideDown();
        });
        
        // set welcome cookie
    });
    
    
    // INTEGRATION
    $('#wcexpress-tab-cbx').click(function(){
        var checked = $(this).prop('checked');
        
        if(checked){
            $('.wcexpress-tab-img').fadeIn();
            $('.wcexpress-tab-off').fadeOut(function(){
                $('.wcexpress-tab-on').fadeIn();    
            });
        } else {
            $('.wcexpress-tab-img').fadeOut();
            $('.wcexpress-tab-on').fadeOut(function(){
                $('.wcexpress-tab-off').fadeIn();  
            });
        }
        
    });
 }

 module.exports = {
    panel,
 };